<template>
  <div class="activty" v-if="activtyType.activty">
    <div class="activtyBox">
      <div v-if="path[0]==''" class="activtyPath">
        <img class="activtyImg" src="../../../static/images/activty/alerthome.svg" />
        <div class="btn" @click="goto(0)"></div>
      </div>
      <div v-if="path[0]=='mycardhobby'&&path[1]=='setting'" class="activtyPath" :class="path[1]">
        <img class="activtyImg" src="../../../static/images/activty/alertaddress.svg" />
        <div class="btn" @click="goto(1)"></div>
      </div>
      <span class="close" @click="activtyType.activty=false"></span>
    </div>
  </div>
</template>
<script>
import {getInfo} from "@/api/public";
import qs from 'qs'
export default {
  name: '',
  components: {},
  data() {
    return {
      path:null,
      userInfo:null,
      activtyType: this.$enumInfo.activtyType,
    }
  },
  watch: {
    '$route': 'getPath'
  },
  mounted() {},
  created() {
    if(process.env.VUE_APP_ACTIVITY){
      this.userInfo=getInfo()
      this.getPath()
    }
  },
  methods: {
    getPath(){
      let that=this;
      this.path = this.$route.path.slice(1).split("/");
      if(this.userInfo!=null){
        if(this.path[0]==''){
          this.getUserActive();
        }else{
          that.activtyType.activty=false;
        }
      }
    },
    //判断用户是否可参与活动
    getUserActive(){
      let that=this;
      let data={MemberId:that.userInfo.Id}
      that.$get(that.$interface.CheckUserActive,data).then(res=>{
        if (res.Result != 0) {
          that.activtyType.activty=true;
        }
      })
    },
    goto(val){
      let url=val!=0?'/mycardhobby/purchase?type=2':'/mycardhobby/setting'
      this.$enumInfo.activtyType.activty=false;
      this.$router.push({
            path: url
          })
    }
  },
}

</script>
<style scoped>
.activty {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.25);
}
.activtyBox{
  width: 400px;
  margin: 0 auto;
  text-align: center;
  /*background-color: #fff;*/
}

.btn{
  cursor: pointer;
  width: 203px;
  height: 48px;
  margin: 35px auto 30px;
  display: block;
}
.activtyPath .btn{
  background: url(../../../static/images/activty/btnhome.svg) no-repeat;
}
.setting .btn{
  background: url(../../../static/images/activty/btnaddress.svg) no-repeat;
}
.activtyImg{
  width: 100%;
  display: block;
}
.close{
  cursor: pointer;
  width: 35px;
  height: 35px;
  display: inline-block;
  background: url(../../../static/images/activty/close.svg) no-repeat;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/activity1.vue